<div class="wrap">
  <div class="form">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class=" login">
        <div class="input">
          <div class="img_label">
            <div class="img">
              <img src="assets/img/icon-blue/license.svg" alt="licence">
            </div>
            <label class="email">Mail</label>
          </div>
          <input type="email" name="username" id="username" formControlName="username"
            (input)="isInactive($event.target.value)">
        </div>
      </div>
      <div class="mdp">
        <div class="input">
          <div class="img_label">
            <div class="img">
              <img src="assets/img/icon-blue/lock_blue.svg" alt="lock" class="lock">
            </div>
            <label>Mot de <br>
              passe</label>
          </div>
          <input type="password" name="password" id="password" formControlName="password"
            (input)="isInactive($event.target.value)">
        </div>
      </div>

      <button [disabled]="loading" [ngClass]="{connexion: inactive || !inactive, inactive: !inactive}">
        <img src="assets/img/icon-white/lock_white.svg" alt="lock">
        Connexion
      </button>
      <div class="back" (click)="back()">
        Retour
      </div>
      <div class="forgot_password">
        <a [routerLink]="['/forgot-password']" routerLinkActive="router-link-active">
          Mot de passe oublié ?
        </a>
      </div>
    </form>
  </div>
</div>
